export default "__VITE_ASSET__DzqcvGtn__"